import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { model } from 'libx';
import { action, observable, toJS } from 'mobx';
import { task } from 'mobx-task';
import { validationContext, pattern, required } from 'validx';
import mapValues from 'lodash/mapValues';
import pick from 'lodash/pick';
import zipObject from 'lodash/zipObject';
import { populateValidationContextFromError } from '../utils/errorUtil';
import TransactionLogViewState from './TransactionLogViewState';
var createCreditForm = function createCreditForm(validationRules) {
  var fields = Object.keys(validationRules);
  var form = {};
  form.validation = validationContext(form, validationRules);
  return model(form).extendObservable(mapValues(validationRules, function () {
    return undefined;
  })).withActions({
    reset: function reset() {
      form.validation.reset();
      form.set(zipObject(fields, fields.map(function (_) {
        return undefined;
      })));
      return form;
    },
    save: function save() {
      if (form.validation.reset().validate().isValid) {
        return toJS(pick(this, fields));
      }
      return false;
    }
  });
};
var TeamCreditViewState = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, _dec5 = action.bound, _dec6 = action.bound, _dec7 = task.resolved, _dec8 = action.bound, _dec9 = action.bound, _dec10 = action.bound, _dec11 = action.bound, _class = /*#__PURE__*/function () {
  function TeamCreditViewState(_ref) {
    var team = _ref.team,
      billingStore = _ref.billingStore,
      flashMessageStore = _ref.flashMessageStore,
      jobStore = _ref.jobStore,
      memberStore = _ref.memberStore;
    _classCallCheck(this, TeamCreditViewState);
    _initializerDefineProperty(this, "showingDepositModal", _descriptor, this);
    _initializerDefineProperty(this, "showingTransactionLogModal", _descriptor2, this);
    _initializerDefineProperty(this, "showingCreditAdminModal", _descriptor3, this);
    _initializerDefineProperty(this, "targetId", _descriptor4, this);
    _initializerDefineProperty(this, "paymentTargetId", _descriptor5, this);
    _initializerDefineProperty(this, "adjustmentAddOrRemove", _descriptor6, this);
    _initializerDefineProperty(this, "currentDepositTab", _descriptor7, this);
    this.depositForm = this.createDepositForm();
    this.creditAdminForm = this.creditAdminForm();
    this.team = team;
    this.billingStore = billingStore;
    this.flashMessageStore = flashMessageStore;
    this.transactionLogViewState = new TransactionLogViewState({
      rootStore: this.billingStore.rootStore
    });
  }
  return _createClass(TeamCreditViewState, [{
    key: "activate",
    value: function () {
      var _activate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function activate() {
        return _activate.apply(this, arguments);
      }
      return activate;
    }()
    /**
     * Adds a billing method.
     */
  }, {
    key: "addBillingMethod",
    value: function addBillingMethod() {
      this.showingCreateBillingModal = false;
      return this.billingStore.showStripeCheckout({
        team: this.team
      });
    }
  }, {
    key: "toggleAdjustmentSwitch",
    value: function toggleAdjustmentSwitch() {
      this.adjustmentAddOrRemove = !this.adjustmentAddOrRemove;
    }
  }, {
    key: "updateCredit",
    value: function () {
      var _updateCredit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var formResult, msg;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              formResult = this.creditAdminForm.save();
              if (formResult) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              msg = this.flashMessageStore.create({
                message: 'Updating Billing Method...',
                inProgress: true
              });
              _context2.prev = 4;
              if (!formResult.limitAmount) {
                _context2.next = 8;
                break;
              }
              _context2.next = 8;
              return this.billingStore.updateBillingMethod(this.targetId, {
                limit: Math.round(parseFloat(formResult.limitAmount) * 100)
              });
            case 8:
              if (!formResult.balanceEditAmount) {
                _context2.next = 11;
                break;
              }
              _context2.next = 11;
              return this.billingStore.adjustCredit(this.targetId, {
                billing_method_id: this.targetId,
                amount: Math.round(parseFloat(formResult.balanceEditAmount) * 100),
                transaction_type: this.adjustmentAddOrRemove ? 'ADMIN_ADD' : 'ADMIN_REMOVE',
                metadata: {
                  description: formResult.description || 'Taxfyle Credit Adjustment'
                }
              });
            case 11:
              this.hideCreditAdminModal();
              msg.done('Credit limit has been changed for account!').autoDismiss();
              _context2.next = 19;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](4);
              populateValidationContextFromError(this.creditAdminForm.validation, _context2.t0);
              throw msg.forError(_context2.t0);
            case 19:
              this.creditAdminForm.reset();
            case 20:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 15]]);
      }));
      function updateCredit() {
        return _updateCredit.apply(this, arguments);
      }
      return updateCredit;
    }()
  }, {
    key: "showDepositModal",
    value: function showDepositModal(methodId) {
      this.targetId = methodId;
      this.showingDepositModal = true;
      this.currentDepositTab = 'SELECT_BILLING';
    }
  }, {
    key: "depositSelectBillingMethod",
    value: function depositSelectBillingMethod(id) {
      this.currentDepositTab = 'DEFAULTPAYMENT';
      this.paymentTargetId = id;
    }
  }, {
    key: "showDepositCustom",
    value: function showDepositCustom(id) {
      this.currentDepositTab = 'CUSTOMPAYMENT';
    }
  }, {
    key: "createDepositForm",
    value: function createDepositForm() {
      return createCreditForm({
        depositAmount: [required(), pattern(/\d*/, 'Must be a number')]
      });
    }
  }, {
    key: "creditAdminForm",
    value: function creditAdminForm() {
      return createCreditForm({
        limitAmount: [pattern(/\d*/, 'Must be a number')],
        balanceEditAmount: [pattern(/\d*/, 'Must be a number')],
        description: []
      });
    }
  }, {
    key: "hideDepositModal",
    value: function hideDepositModal() {
      this.showingDepositModal = false;
      this.targetId = null;
      this.currentDepositTab = 'SELECT_BILLING';
    }
  }, {
    key: "saveDeposit",
    value: function () {
      var _saveDeposit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var formResult, msg;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              formResult = this.depositForm.save();
              if (formResult) {
                _context3.next = 3;
                break;
              }
              return _context3.abrupt("return");
            case 3:
              msg = this.flashMessageStore.create({
                message: 'Processing transaction and adding amount to credit balance...',
                inProgress: true
              });
              _context3.prev = 4;
              _context3.next = 7;
              return this.billingStore.depositCredit(this.targetId, {
                payment_method_id: this.paymentTargetId,
                billing_method_id: this.targetId,
                amount: Math.round(parseFloat(formResult.depositAmount) * 100),
                metadata: {
                  description: 'Taxfyle Credit balance payment'
                }
              });
            case 7:
              this.hideDepositModal();
              msg.done('Amount has been deposited into credit account!').autoDismiss();
              _context3.next = 14;
              break;
            case 11:
              _context3.prev = 11;
              _context3.t0 = _context3["catch"](4);
              throw msg.forError(_context3.t0);
            case 14:
              this.depositForm.reset();
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[4, 11]]);
      }));
      function saveDeposit() {
        return _saveDeposit.apply(this, arguments);
      }
      return saveDeposit;
    }()
  }, {
    key: "showTransactionModal",
    value: function showTransactionModal(billingMethodId) {
      this.transactionLogViewState.activate({
        billingMethodId: billingMethodId
      });
      this.showingTransactionLogModal = true;
    }
  }, {
    key: "hideTransactionModal",
    value: function hideTransactionModal() {
      this.showingTransactionLogModal = false;
    }
  }, {
    key: "showCreditAdminModal",
    value: function showCreditAdminModal(methodId) {
      this.targetId = methodId;
      this.showingCreditAdminModal = true;
    }
  }, {
    key: "hideCreditAdminModal",
    value: function hideCreditAdminModal() {
      this.showingCreditAdminModal = false;
      this.targetId = null;
    }
  }]);
}(), _descriptor = _applyDecoratedDescriptor(_class.prototype, "showingDepositModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "showingTransactionLogModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "showingCreditAdminModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "targetId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "paymentTargetId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "adjustmentAddOrRemove", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return true;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "currentDepositTab", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 'SELECT_BILLING';
  }
}), _applyDecoratedDescriptor(_class.prototype, "addBillingMethod", [action], Object.getOwnPropertyDescriptor(_class.prototype, "addBillingMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleAdjustmentSwitch", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "toggleAdjustmentSwitch"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCredit", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "updateCredit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDepositModal", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "showDepositModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "depositSelectBillingMethod", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "depositSelectBillingMethod"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showDepositCustom", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "showDepositCustom"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideDepositModal", [_dec6], Object.getOwnPropertyDescriptor(_class.prototype, "hideDepositModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveDeposit", [_dec7, action], Object.getOwnPropertyDescriptor(_class.prototype, "saveDeposit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showTransactionModal", [_dec8], Object.getOwnPropertyDescriptor(_class.prototype, "showTransactionModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideTransactionModal", [_dec9], Object.getOwnPropertyDescriptor(_class.prototype, "hideTransactionModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCreditAdminModal", [_dec10], Object.getOwnPropertyDescriptor(_class.prototype, "showCreditAdminModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hideCreditAdminModal", [_dec11], Object.getOwnPropertyDescriptor(_class.prototype, "hideCreditAdminModal"), _class.prototype), _class);
export { TeamCreditViewState as default };
//# sourceMappingURL=TeamCreditViewState.js.map
